export function JoinFilter() {
    return function (input, delimiter) {
        return (input || []).join(delimiter || ", ");
    };
}
